<template>
  <div :class="$style.container">
    <div :class="$style.card">
      <div :class="$style.settContainer">
        <div :class="$style.label">
          {{ $t('contact.label') }}
        </div>
        <div :class="$style.msgr">
          <button
            v-if="isViewBtn"
            :class="[$style.addUserButton, { [$style.disabled]: !disabledAddContactBtn }]"
            :disabled="!disabledAddContactBtn"
            @click="addNewContact()"
          >
            {{ $t('contact.addNew') }}
          </button>
          <button
            :class="[$style.addUserButton, { [$style.disabled]: !disabledSaveBtn }]"
            :disabled="!disabledSaveBtn"
            @click="saveContact()"
          >
            {{ $t('contact.saveChanges') }}
          </button>
        </div>
      </div>
      <div :class="$style.settContainer">
        <label :class="$style.label">{{ $t('global.FCs') }}:</label>
        <input
          v-model="person"
          :class="$style.select"
        >
      </div>

      <div :class="$style.settContainer">
        <label :class="$style.label">{{ $t('settings.contactType') }}:</label>
        <select
          v-model="type"
          :class="$style.select"
        >
          <option
            v-for="type in typeDetails"
            :key="type.id"
            :value="type.id"
          >
            {{ type.name }}
          </option>
        </select>
      </div>
      <div :class="$style.settContainer">
        <div :class="$style.label">
          {{ $t('settings.mailAndMessengers') }}
        </div>
        <button
          :class="[$style.addUserButton, { [$style.disabled]: !disabledAddBtn }]"
          :disabled="!disabledAddBtn"
          @click="addMsgr()"
        >
          {{ $t('global.add') }}
        </button>
      </div>
      <div :class="$style.settContainer">
        <label :class="$style.label">E-mail:</label>
        <div :class="$style.inline">
          <input
            v-model="login"
            :class="$style.select"
          >
        </div>
      </div>
      <div :class="$style.settContainer">
        <label :class="$style.label">{{ $t('settings.typesOfMessengers') }}</label>
        <select
          v-model="messenger"
          :class="$style.select"
        >
          <option
            v-for="msg in messengers"
            :key="msg.id"
            :value="msg.id"
          >
            {{ msg.name }}
          </option>
        </select>
      </div>
    </div>

    <loader v-if="isLoader" />
    <div
      v-else
      :class="$style.table"
    >
      <dragTreeTable
        :data="treeData"
        @deleteItem="(item) => actionMsgr(item, true)"
        @saveNewName="(item) => actionMsgr(item)"
      >
        <template #type="{ row }">
          <div :class="$style.msgr">
            <img
              :src="getMessengerIconById(row.type)"
              :alt="getMessengerLabelById(row.type)"
              :title="row.login"
              :class="$style.img"
            >
            {{ getMessengerLabelById(row.type) }}
          </div>
        </template>
      </dragTreeTable>
    </div>
  </div>
</template>

<script>
  import { MESSENGER_LABEL_BY_ID, getMessengerIconById, getMessengerLabelById } from '@/helpers/messengers';
  import { TYPE_DETAILS } from '@/views/security/relations/const/const';
  import {
    getLinksContact,
    getLinkContactFromRelations,
    addContactMsgr,
    deleteContactMsgr,
    editContactMsgr,
    saveContactInfo,
    addContact,
  } from '@/api/methods/settings';
  import dragTreeTable from '@/components/pages/agents/drag-tree-table/dragTreeTable.vue';
  import Loader from '@/components/common/blocks/loader.vue';

  export default {
    components: {
      dragTreeTable,
      Loader,
    },
    props: ['compData'],
    data() {
      return {
        isLoader: false,
        login: '',
        initLogin: '',
        messenger: null,
        initType: null,
        type: null,
        initPerson: null,
        person: null,
        contactInfo: {},
        typeDetails: TYPE_DETAILS,
        messengers: [],
        treeData: {
          columns: [
            {
              type: 'selection',
              title: this.$t('settings.columns.login'),
              field: 'login',
              padding: '5px',
              align: 'left',
              flex: 1,
            },
            {
              type: 'type',
              title: this.$t('settings.columns.type'),
              field: 'type',
              maxWidth: '15%',
              padding: '5px',
              align: 'left',
              flex: 2,
            },
            {
              type: 'action',
              title: this.$t('settings.columns.action'),
              maxWidth: '15%',
              padding: '5px',
              align: 'left',
              flex: 3,
              actions: [
                {
                  text: this.$t('settings.columns.actions.changeName'),
                  eventName: 'changeName',
                  formatter: () => '',
                },
                {
                  text: this.$t('settings.columns.actions.saveNewName'),
                  eventName: 'saveNewName',
                  formatter: () => '',
                },
                {
                  text: this.$t('settings.columns.actions.deleteItem'),
                  eventName: 'deleteItem',
                  formatter: () => '',
                },
                {
                  text: this.$t('settings.columns.actions.cancelChange'),
                  eventName: 'cancelChange',
                  formatter: () => '',
                },
              ],
            },
          ],
          lists: [],
          custom_field: {
            id: 'ident',
            lists: 'children',
            parent_id: 'category',
          },
        },
      };
    },

    computed: {
      isViewBtn() {
        return this.$route.name !== 'agents-agent-settings';
      },
      disabledAddContactBtn() {
        if (!this.contactInfo?.id) return this.type >= 0 && this.person;
        return this.type >= 0 && this.person && this.disabledSaveBtn;
      },
      disabledSaveBtn() {
        if (!this.contactInfo?.id) return false;
        return this.initType !== this.type || this.initPerson !== this.person;
      },
      disabledAddBtn() {
        if (!this.contactInfo?.id) return false;
        return this.initLogin !== this.login;
      },
    },

    watch: {
      compData: {
        handler(newVal) {
          if (newVal) {
            this.isAddBtn = true;
            this.fetch();
          }
        },
        immediate: true,
      },
    },
    async created() {
      this.messengers = Object.entries(MESSENGER_LABEL_BY_ID).map(([id, name]) => ({
        name,
        id,
      }));
      this.messenger = this.messengers[0].id;
      await this.fetch();
    },
    methods: {
      async fetch() {
        try {
          this.isLoader = true;
          let result;
          if (this.$route.name === 'agents-agent-settings') {
            const { computer, compName, userName } = this.$route.params;
            const { result: linkContacts } = await getLinksContact(computer, compName, userName, true);
            result = linkContacts;
          } else if (this.compData.cid) {
            const { id, cid } = this.compData;
            const { result: linkContactsRelations } = await getLinkContactFromRelations(id, cid);
            result = linkContactsRelations;
          } else {
            result = { contactInfo: [this.compData] };
          }
          if (!result) return;
          this.contactInfo = result?.contactInfo[0] || {};
          this.treeData.lists = result?.contactMsgr || [];
          this.type = this.contactInfo?.details;
          this.initType = this.contactInfo?.details;
          this.person = this.contactInfo?.person;
          this.initPerson = this.contactInfo?.person;
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoader = false;
        }
      },
      async addNewContact() {
        try {
          this.isLoader = true;
          await addContact(this.person, this.person, this.type, '');
          this.$emit('update');
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoader = false;
        }
      },
      async saveContact() {
        try {
          this.isLoader = true;
          const person = this.initPerson !== this.person ? this.person : '';
          const type = this.initType !== this.type ? this.type : null;
          await saveContactInfo(this.contactInfo.id, person, type);
          await this.fetch();
          this.$emit('update');
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoader = false;
        }
      },

      async addMsgr() {
        if (!this.messenger || !this.login) return;
        try {
          this.isLoader = true;
          await addContactMsgr(this.contactInfo.id, this.messenger, this.login, '');
          await this.fetch();
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoader = false;
        }
      },

      async actionMsgr(item, isDelete = false) {
        try {
          this.isLoader = true;
          if (isDelete) await deleteContactMsgr(item.id);
          else await editContactMsgr(item.id, item.login);
          await this.fetch();
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoader = false;
        }
      },
      getMessengerIconById(id) {
        return getMessengerIconById(id);
      },
      getMessengerLabelById(id) {
        return getMessengerLabelById(id);
      },
    },
  };
</script>

<style lang="scss" module>
  .container {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px 0px 15px 22px;
    width: 92%;
    padding: 5px;
  }
  .settContainer {
    display: flex;
    padding: 10px 0px;
    margin: 0px 10px;
    justify-content: space-between;
    align-items: center;
  }

  .label {
    margin: 0px 10px;
    font-size: 14px;
  }

  .card {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .table {
    margin: 10px;
    overflow: auto;
    height: 100%;
    flex-direction: column;
    display: flex;
  }

  .msgr {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  .select {
    height: 24px;
    width: 160px;
  }
  .addUserButton {
    border: 1px solid white;
    background: #2985bf;
    cursor: pointer;
    height: 30px;
    color: white;
    width: 160px;
    &.disabled {
      cursor: not-allowed;
      background: #c4c4c4;
    }
  }

  .img {
    max-height: 20px;
  }
</style>
